<template>
  <div>
    <!-- Edit -->
    <a-modal
      v-model="visible"
      title="Edit Privacy-Policy Details"
      onOk="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleEdit"
          >Edit Privacy</a-button
        >
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Phone">

            <a-input
              placeholder="Phone"
              v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input a valid Phone!',
                      pattern: new RegExp(`^[0-9]{7,14}$`),
                    },
                  ],
                },
              ]"
            >
              <a-select
                slot="addonBefore"
                v-decorator="['country_code', { initialValue: '91' }]"
                style="width: 70px"
              >
                <a-select-option
                  v-for="countryCode in countryCodes"
                  :value="countryCode.value"
                  :key="countryCode.value"
                >
                  <span class="text-bold">{{ countryCode.name }}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>

          <a-form-item label="Email">
            <a-input
              placeholder="Email"
              v-decorator="[
                'email_id',
                { rules: [{ required: true, message: 'Please input Email!' }] },
              ]"
            />
          </a-form-item>
            <a-form-item label="Address">
              <a-input
                placeholder="Address"
                v-decorator="[
                  'address',
                  {
                    rules: [
                      { required: true, message: 'Please input Address !' },
                    ],
                  },
                ]"
              />
            </a-form-item>

            <a-form-item label="Terms and Condition">
              <a-input
                placeholder="Terms and Conditions"
                v-decorator="[
                  'terms_and_conditions',
                  {
                    rules: [
                      { required: true, message: 'Please input Terms and Condition !' },
                    ],
                  },
                ]"
              />
            </a-form-item>

            <a-form-item label="Privacy Policy">
              <a-input
                placeholder="Privacy Policy"
                v-decorator="[
                  'privacy_policy',
                  {
                    rules: [
                      { required: true, message: 'Please input Privacy Policy !' },
                    ],
                  },
                ]"
              />
            </a-form-item>

             <a-form-item label="About Us">
              <a-input
                placeholder="About Us"
                v-decorator="[
                  'about_us',
                  {
                    rules: [
                      { required: true, message: 'Please input About Us !' },
                    ],
                  },
                ]"
              />
            </a-form-item>

        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'
import { countryCodes } from '@/services/globaldata'

export default {
  name: 'EditPrivacyPolicy',
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      // boardId: null,
      school_id: '',
      countryCodes,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openPolicyEditModel', this.showModal)
  },
  methods: {
    showModal: function (schoolId) {
      this.school_id = schoolId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http
        .get('/api/school-privacy-policy/' + this.$route.params.id)
        .then(({ data }) => {
          const editData = pick({ ...data.data }, [
            'address',
            'email_id',
            'phone',
            'terms_and_conditions',
            'privacy_policy',
            'about_us',
          ])
          const fieldsData = mapValues({ ...editData }, function (value) {
            return value !== null ? value : undefined
          })
          this.form.setFieldsValue(fieldsData)
          this.spinning = false
          this.loading = false
        })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/privacy/' + this.school_id, {
                  address: values.address,
                  email_id: values.email_id,
                  phone: values.phone,
                  terms_and_conditions: values.terms_and_conditions,
                  privacy_policy: values.privacy_policy,
                  about_us: values.about_us,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Privacy Policy details edited successfully!',
                  })
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
